import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

const Booking = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const whatsappMessage = encodeURIComponent(
    `Hello Centurio Prime Team,\n\nI would like to reserve a snooker table.\n\nPreferred Date: [Please Enter Date]\nPreferred Time: [Please Enter Time]\nNumber of Players: [Enter Number]\n\nKindly confirm availability.\n\nThank you.`
  );

  const whatsappLink = `https://wa.me/923016697234?text=${whatsappMessage}`;

  return (
    <section
      id="booking"
      ref={ref}
      className="py-20 md:py-32 bg-neutral-950 relative overflow-hidden"
      data-testid="booking-section"
    >
      {/* Background Accent */}
      <div className="absolute bottom-0 right-0 w-96 h-96 spotlight-effect opacity-20"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            className="font-cinzel text-4xl md:text-5xl font-semibold text-gold mb-4 tracking-wide"
            data-testid="booking-title"
          >
            Reserve Your Table
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="font-montserrat text-lg text-neutral-300">
            Book your exclusive snooker experience at Centurio Prime
          </p>
        </motion.div>

        {/* Booking Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-black/50 border border-neutral-800 p-8 md:p-12 rounded-sm"
          data-testid="booking-card"
        >
          <div className="text-center space-y-8">
            {/* Icon */}
            <div className="flex justify-center">
              <div className="w-20 h-20 rounded-full border-2 border-gold flex items-center justify-center">
                <MessageCircle className="w-10 h-10 text-gold" />
              </div>
            </div>

            {/* Content */}
            <div className="space-y-4">
              <h3 className="font-cinzel text-2xl md:text-3xl text-gold">
                Book via WhatsApp
              </h3>
              <p className="font-montserrat text-neutral-400 leading-relaxed">
                Send us a message on WhatsApp to reserve your table. Our team will confirm your booking promptly.
              </p>
            </div>

            {/* CTA Button */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 btn-primary gold-glow-hover"
              data-testid="booking-whatsapp-button"
            >
              <MessageCircle className="w-5 h-5" />
              Book Now on WhatsApp
            </a>

            {/* Alternative - Call */}
            <div className="pt-6 border-t border-neutral-800">
              <p className="font-montserrat text-sm text-neutral-400 mb-3">
                Prefer to call?
              </p>
              <a
                href="tel:+923016697234"
                className="inline-block btn-outline"
                data-testid="booking-call-button"
              >
                Call 0301-6697234
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Booking;
